import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}

export default function Card({ children, title, subtitle, action, className = '' }: CardProps) {
  return (
    <div className={`bg-gradient-to-br from-[rgba(21,24,35,0.96)] to-[rgba(8,9,17,0.98)] rounded-2xl border border-border-soft p-3 sm:p-3.5 ${className}`}>
      {(title || subtitle || action) && (
        <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-2.5 gap-2 sm:gap-3">
          <div className="min-w-0">
            {title && <div className="text-[0.85rem] sm:text-[0.9rem] font-medium">{title}</div>}
            {subtitle && <div className="text-[0.72rem] sm:text-[0.75rem] text-text-soft">{subtitle}</div>}
          </div>
          {action && <div className="flex-shrink-0">{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
